import React, { useEffect, useState } from 'react'

import { getNameOnDate } from 'name-day-calendar'
import type { TStringDate } from 'name-day-calendar/dist/types'
import DatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import amaniPointing from '../assets/amani_pointing.png'
import axiosClient from '../service/axiosClient'
import { CalendarEvent } from '../types/Calendar'

export const SideCalendar = () => {
    const {t, i18n} = useTranslation()
    // Kept in component state rather than localStorage: a stored date outlived the day it was
    // chosen on, so the widget opened on whatever day it was last used instead of on today.
    const [startDate, setStartDate] = useState<Date>(new Date())

    const [myEvents, setEvents] = useState<CalendarEvent[]>([])
    const navigate = useNavigate()
    const [meniny, setMeniny] = useState('')

    useEffect(() => {
        if (startDate) {
            console.log('downloading events')
            axiosClient.get<CalendarEvent[]>('calendar-event/for-date', {
                params: {
                    date: new Date(startDate).toISOString().split('T')[0]
                }
            })
                .then(response => {
                    console.log('res', response)
                    // const eventsTmp: CalendarEvent[] = []
                    // response.data.content.forEach(item => {
                    //     const start = new Date(item.entryDate + 'T' + item.startedAt)
                    //     const end = new Date(item.entryDate + 'T' + item.endedAt)
                    //
                    //     eventsTmp.push({
                    //         id: item.id as number,
                    //         title: item.title,
                    //         start: start,
                    //         end: end,
                    //         color: item.color,
                    //         // allDay: true
                    //     })
                    // })
                    // console.log('eventsTmp', eventsTmp)
                    // setEvents(eventsTmp)
                    setEvents(response.data)
                }).catch(error => {
                console.log('error', error)
            })
        }
    }, [startDate])

    useEffect(() => {

        (async () => {
            // get all name days on a specific date and just for Slovakia.
            const today = new Date()
            const month = today.getMonth() + 1 // getMonth() vracia 0-11, preto +1
            const day = today.getDate()

            const dateString = `${month}-${day}`

            const name: string[] = await getNameOnDate(dateString as TStringDate, {lang: 'SK'}) as string[]
            if (Array.isArray(name) && name.length) {
                setMeniny(name.join(', '))
            }
        })()
    }, [])

    return (
        <div className={'side-calendar'}>
            <div className="d-flex justify-content-space-between">
                <div>
                    <strong>{t('name_day')} </strong><br/><span className={'font-rubik'}>{meniny}</span>
                </div>
            </div>

            <br/>
            {/*<h5>Kalendár</h5>*/}
            <DatePicker
                selected={new Date(startDate)}
                locale="sk"
                dateFormat="dd.MM.yyyy"
                onChange={(date) => {
                    if (date) {
                        setStartDate(date)
                    }
                }}
                inline
            />

            {/*<div className="side-calendar-day-title">*/}
            {/*    {startDate.toLocaleDateString()}*/}
            {/*</div>*/}

            <Link to={'/app/calendar/add'}><button className={'btn amani-primary pink-btn small w-100'}>+ {t('add_event')}</button></Link>
            <div className={'d-flex flex-row mt-3'}>
                <div>

                    <img width={60} src={amaniPointing}/>
                </div>
                <div>
                    {/*<h5 className={'mt-1 mb-1'}>Udalosti</h5>*/}
                    {/*<h5 className={'mt-1 mb-1'}>&nbsp;</h5>*/}
                    <div className="current-date">{new Date(startDate).toLocaleDateString(i18n.language === 'en' ? 'en-US' : i18n.language === 'cs' ? 'cs-CZ' : 'sk-SK')}</div>
                </div>

            </div>

            <div className="event-wrapper">
                {Array.isArray(myEvents) && myEvents.length ? myEvents.map(event => (
                    <div
                        onClick={() => navigate('/app/calendar/edit/' + event.id)}
                        key={event.id}
                        className="event-item cursor-pointer">
                        <div className="time"
                             style={{backgroundColor: event.color}}>{event.startedAt?.slice(0, -3) || ''}</div>
                        <div className="info">
                            {/*<div className="client">{`${event.firstName} ${event.lastName}`}</div>*/}
                            <div className="client">{event.name}</div>
                            {/*<div className="title">{event.name}</div>*/}
                        </div>
                    </div>
                )) : <div className="no-events">{t('no_events')}</div>}

                {/*<div className="event-item">*/}
                {/*    <div className="time">08:00</div>*/}
                {/*    <div className="info">*/}
                {/*        <div className="client">Ranný beh</div>*/}
                {/*        <div className="title">Beh v parku</div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="event-item">*/}
                {/*    <div className="time">12:00</div>*/}
                {/*    <div className="info">*/}
                {/*        <div className="client">Ranný beh</div>*/}
                {/*        <div className="title">Beh v parku</div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="event-item">*/}
                {/*    <div className="time">16:30</div>*/}
                {/*    <div className="info">*/}
                {/*        <div className="client">Ranný beh</div>*/}
                {/*        <div className="title">Beh v parku</div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}